import { Check, Close } from '@mui/icons-material'
import React from 'react'
import { Typography } from '../../design_system/StyledComponents/components/Typography';
import { Button } from '../../design_system/StyledComponents/components/Button';
import "./PaymentConfirmationPopup.css"
import { useDispatch, useSelector } from 'react-redux';
import { setShowPaymentConfirmationPopup } from '../../Actions/ApplicationStateAction';

const PaymentConfirmationPopup = () => {
    const {showPaymentConfirmationPopup} = useSelector((state) => state.ApplicationState);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setShowPaymentConfirmationPopup(false))
    }

    const handleBackToDashboard = () => {
        handleClose();
        // window.location.href = process.env.REACT_APP_ROME_URL + "/my-homes"
        const timestamp = new Date().getTime();
        window.location = `${process.env.REACT_APP_ROME_URL}/my-homes?ts=${timestamp}`;
    }
    return (
        showPaymentConfirmationPopup &&
        <div className='payment-confirmation-popup-container'>
            <div className='payment-confirmation-popup-content'>
                <div className="upgrade-popup-close">
                    <Close
                        style={{ cursor: "pointer", color: "black" }}
                        onClick={handleClose}
                    />
                </div>
                <div className='payment-confirmation-popup-check'>
                    <Check />
                </div>
                <div className='payment-confirmation-popup-text'>
                    <Typography modifiers={["header5", "bold"]} style={{color:"#509F9B"}}>Payment successful!</Typography>
                    <Typography modifiers={["subtitle1"]} style={{color:"#6E757A"}}>You will receive 3D of your home within 1 business day</Typography>
                </div>
                <hr />
                <Button onClick={handleBackToDashboard} modifiers={["outlineBlack"]}>Back to Dashboard</Button>
            </div>
        </div>
    )
}

export default PaymentConfirmationPopup
